import { h, Fragment } from 'preact';

const ProductBadge = ({ badge }) => {
  return (
    <span className="inline-block bg-grey-250 rounded-sm text-xs leading-[16px] py-[4.5px] px-[8.5px] mb-[10px]">
      {badge}
    </span>
  );
};

export default ProductBadge;
